export enum UserPermission {
	// Admin
	CanCreateGrowers = 'User can create growers',
	CanManageAnyAccount = 'CanImpersonate',
	CanRecord = 'Allow:Record',
	CanSeeTroubleShootingTools = 'Expose troubleshooting tools',
	UserAdministrator = 'Allow:UserAdmin',

	// Pricing and Orders
	CanSeePricing = 'Allow:Pricing', // Whether or not the user can see pricing
	CanSendOrders = 'Allow: Send Order', // If a user cannot send an Order, they can send a Quote

	// Features
	CanConfirmfields = 'Allow: Field Confirm',
	CanSeeCompetitiveAllowance = 'Allow:Competitive Allowance',
	CanSeePPG = 'Allow Product Placement Guide',
	CanSeeProductPlanRecommendations = 'Allow:ProductPlanRecommendation',

	// SSO
	CropEdgeSSO = 'Allow:CropEdgeSSO',
	GhxCoreSSO = 'Allow:SSO:core',
	LogisticsSSO = 'Allow:SSO:logistics',

	// Grower specific
	// A Grower's viewpoint is different from a seller/dealer's view, so this permission is used to determine if the user is a grower
	IsGrower = 'Allow:Grower UI Access',

	// Themes and Brands
	CanAccessEnogen = 'Enogen Dealer',
	CanSeeEnogenBrand = 'Allow:Brand:Enogen',
	CanSeeEnogenTheme = 'Theme:Enogen', // Whether or not the user can see the Enogen theme
	CanSeeGHTheme = 'Theme:GH', // Whether the user is GH or not (there is no current GH theme, so this user will see the GHX theme with some minor differences)
	CanSeeGHXTheme = 'Theme:GHX', // Whether the user is GHX or not (and thus can see the GHX theme)

	// Sites
	CanSeeEluSolutionsSite = 'Allow: Eluminate Solutions', // Whether or not the user can see the eluminate.solutions site
}